import type { ReactNode } from "react";
import { Box, Stack } from "@mui/material";

export const AssistantProposalFrame = ({ gap, children }: { gap: number; children: ReactNode }) => (
  <Box
    sx={{
      maxWidth: 680,
      py: 3,
      px: 4,
      borderRadius: 1,
      border: "1px solid",
      borderColor: "divider",
      bgcolor: "background.paper",
    }}
  >
    <Stack sx={{ gap }}>{children}</Stack>
  </Box>
);
